module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zoom"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    attrs: {
      "disabled": _vm.transform === 1
    },
    on: {
      "click": function($event) {
        return _vm.zoomIn()
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button is-light",
    attrs: {
      "disabled": _vm.transform <= 0.5
    },
    on: {
      "click": function($event) {
        return _vm.zoomOut()
      }
    }
  }, [_vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-search-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-search-minus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38d19f02"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/Zoom.vue
// module id = 580
// module chunks = 42